import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useInfiniteQuery } from '@tanstack/react-query';
import playlistKeys from './queryKeys';
import api from 'utils/api';
export default function useFetchMyBrowsePlaylists(_ref) {
  var _data$pages;
  var _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 24 : _ref$limit,
    topic = _ref.topic,
    sort = _ref.sort,
    duration = _ref.duration,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params,
    enabled = _ref.enabled;
  // Request browse response
  function fetchMyBrowsePlaylists(_x) {
    return _fetchMyBrowsePlaylists.apply(this, arguments);
  }
  function _fetchMyBrowsePlaylists() {
    _fetchMyBrowsePlaylists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var pageParam, allParams, data;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            pageParam = _ref2.pageParam;
            allParams = _objectSpread(_objectSpread({}, params), pageParam);
            if (duration) {
              allParams.duration = duration;
            }
            if (sort) {
              allParams.sort = sort;
            }
            if (topic) {
              allParams.topic = topic;
              allParams.sort = 'topic_rank';
            }
            _context.next = 1;
            return api('get', '/api/me/browse', _objectSpread({
              offset: offset,
              limit: limit,
              format: 'list'
            }, allParams));
          case 1:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchMyBrowsePlaylists.apply(this, arguments);
  }
  var keyParams = _objectSpread(_objectSpread({}, params), {}, {
    topic: topic,
    sort: sort,
    duration: duration
  });
  var _useInfiniteQuery = useInfiniteQuery({
      queryKey: playlistKeys.myPlaylistsToBrowse(offset, limit, keyParams),
      queryFn: fetchMyBrowsePlaylists,
      initialPageParam: undefined,
      getNextPageParam: function getNextPageParam(_ref3) {
        var nextOffset = _ref3.nextOffset;
        return nextOffset ? {
          offset: nextOffset
        } : undefined;
      },
      enabled: enabled
    }),
    data = _useInfiniteQuery.data,
    queryProps = _objectWithoutProperties(_useInfiniteQuery, _excluded);
  var items = (data === null || data === void 0 || (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.flatMap(function (_ref4) {
    var items = _ref4.items;
    return items;
  })) || [];
  return _objectSpread({
    items: items
  }, queryProps);
}